import { Component, Event, EventEmitter, h, Host } from '@stencil/core';

import wcShared from '@web-components/shared';

import { Store } from '../../../../utils/Stores/store';

@Component({
  tag: 'modal-close-module',
  styleUrl: 'modal-close-module.scss',
  shadow: true,
})
export class ModuleModalClose {
  @Event() closeEvent: EventEmitter;

  private close(type: 'quit' | 'close') {
    if (type === 'close') {
      Store?.set('displayModal', false);
    } else {
      this.closeEvent.emit();
    }
  }

  render() {
    return (
      <Host>
        <div class="modal-close">
          <p>
            {wcShared?.translate(
              'Attention, vous etes sur le point de fermer la fenetre de redaction de votre mail, il sera definitivement perdue.',
            )}
          </p>
          <div class="action">
            <button
              onClick={() => {
                this.close('quit');
              }}
            >
              {wcShared?.translate('Quitter')}
            </button>
            <button onClick={() => this.close('close')}>{wcShared?.translate('Annuler')}</button>
          </div>
        </div>
      </Host>
    );
  }
}
